import { get } from 'lodash';

import { SUPPORTED_LOCALES } from 'constants/locales';
import Model from 'models';
import Settings from 'utils/Settings';

const FaqItemModel = class extends Model {
  localizedValue(field) {
    return get(
      this._data,
      [field, Settings.currentLocale],
      get(this._data, [field, SUPPORTED_LOCALES.EN_US])
    );
  }

  get question() {
    return this.localizedValue('question');
  }

  get answer() {
    return this.localizedValue('answer');
  }
};

export default FaqItemModel;
